/* 🤖 this file was generated by svg-to-ts */
export const matIconFilter9: {
  name: 'filter-9';
  data: string;
} = {
  name: 'filter-9',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 4h-2V7h2v2z"/></svg>`
};
